export default __webpack_public_path__ + "static/media/security.8cd3dbb7.jpg";